var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ITEMS_CHUNK_SIZE } from "../../constants";
import { recalculatePagination } from "../recalculatePagination";
import { updateAllRegions } from "../updateAllRegions";
export const getData = (bff, requestType, request) => __awaiter(this, void 0, void 0, function* () {
    let items = [];
    try {
        let response = yield bff[requestType.method](request);
        items = response[requestType.entity] || [];
        updateAllRegions(response.regions);
    }
    catch (error) {
        console.error(error);
    }
    if (items && items.length >= ITEMS_CHUNK_SIZE && request.pagination) {
        request.pagination = recalculatePagination(request.pagination);
        items = items.concat(yield getData(bff, requestType, request));
    }
    return items;
});
//# sourceMappingURL=getData.js.map